import React, { createContext, useContext, useEffect, useState } from 'react';
import { ref, onValue, get, set, update, push } from 'firebase/database';
import { useAuth } from 'src/views/authentication/AuthContext';
import { database } from 'src/book/src/firebase';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useParams } from 'react-router';
import { useAuthShop } from '../shop/AuthShopContext';

const ShopContext = createContext();

// take user id from business mapping
//

export const ShopProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [businessInfo, setBusinessInfo] = useState([]);
  // const [bizId, setBizId] = useState(null)

  const { bizId } = useAuthShop();

  // Function to fetch products
  useEffect(() => {
    if (!bizId) {
      setProducts([]);
      return;
    }
    const productsRef = ref(database, `billing/products/${bizId}`);
    onValue(
      productsRef,
      (snapshot) => {
        const loadedProducts = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const value = childSnapshot.val();
          loadedProducts.push({ id: key, ...value });
        });

        const productsFiltered = loadedProducts.filter((pr) => pr.isHidden !== true);
        setProducts(loadedProducts);
      },
      {
        onlyOnce: false,
      },
    );
  }, [bizId]);

  useEffect(() => {
    const fetchBizInfo = async () => {
      try {
        const dbRef = ref(database, `/biz/userInfo/${bizId}`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          setBusinessInfo(snapshot.val());
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Whenever bizId changes, update localStorage

    if (bizId !== null) {
      fetchBizInfo();
    }
  }, [bizId]);

  return (
    <ShopContext.Provider
      value={{
        products,
        businessInfo,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
